import styled from 'styled-components'

export const ReloadButtonCustom = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 8px;
  cursor: pointer;
  color: white;
  border: ${({theme}) => `1px solid ${theme.colors.primary}`};
  background: transparent;
  text-transform: initial;
  font-family: 'Inter; sans-serif';
  font-size: 0.875em;
  font-weight: 500;
  font-style: normal;
  background-color: white;
  transition: 0.3s;
  @media (max-width: 767px) {
    display: none;
  }
`
